export function Spinner({ size = 16 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" className="spin text-white/70" fill="none" stroke="currentColor" strokeWidth={2.4}>
      <circle cx="12" cy="12" r="9" strokeDasharray="46 14" strokeLinecap="round" />
    </svg>
  );
}
